// extracted by mini-css-extract-plugin
export default {"headerCardMiniTab":"MPUsS_KlsYvpdebiTzGk"};